import { MaintenanceWindowSelectorController } from '../controller/MaintenanceWindowSelectorController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { MaintenanceWindowTypeAttributes } from '../../../types/common/maintenanceWindowTypes';
import { MaintenanceWindowShort } from '../types';

export class MaintenanceWindowSelectorWebComponent extends BaseWebComponentElement {
  public controller: MaintenanceWindowSelectorController | null;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: MaintenanceWindowSelectorController,
    });
  }

  get value(): string {
    const value = this.getAttribute('value');

    if (value === null) {
      return '';
    }

    return value;
  }

  set value(value: string) {
    this.setAttribute('value', value);

    // Re-render component when selected value changes
    this.propertiesSet = true;
  }

  /**
   * Sets value silently
   *
   * @param realValue
   */
  setRealValue(realValue?: MaintenanceWindowShort) {
    if (!realValue) {
      this.setAttribute('value', '');
      return;
    }

    this.setAttribute('value', JSON.stringify([realValue]));
  }

  getRealValue(): MaintenanceWindowShort | null {
    if (!this.value) {
      return null;
    }

    try {
      const realValue = JSON.parse(this.value);

      if (!realValue[0]) {
        return null;
      }

      return realValue[0];
    } catch (error) {
      // ignore error
    }

    return null;
  }

  getValueId(): string {
    const realValue = this.getRealValue();

    if (realValue) {
      return realValue.id;
    }

    return '';
  }

  getValueName(): string {
    const realValue = this.getRealValue();

    if (realValue) {
      return realValue.name;
    }

    return '';
  }

  get companyId(): string {
    const value = this.getAttribute('data-companyId');

    if (value === null) {
      return '';
    }

    return value;
  }

  set companyId(value: string) {
    this.setAttribute('data-companyId', value);
  }

  get type(): number | null {
    const attributeValue = this.getAttribute('data-maintenance-window-type');

    if (
      attributeValue === null ||
      attributeValue === '' ||
      MaintenanceWindowTypeAttributes[attributeValue] === undefined
    ) {
      return null;
    }

    return MaintenanceWindowTypeAttributes[attributeValue];
  }

  set type(value: number | null) {
    if (value === this.type) {
      // Debounce value change
      return;
    }

    if (value === null || MaintenanceWindowTypeAttributes[value] === undefined) {
      this.setAttribute('data-maintenance-window-type', '');
      return;
    }

    this.setAttribute('data-maintenance-window-type', MaintenanceWindowTypeAttributes[value]);

    // TODO: re-render component?
  }

  set readOnly(value: boolean) {
    if (value) {
      this.setAttribute('readonly', '');
    } else {
      this.removeAttribute('readonly');
    }
  }

  get readOnly(): boolean {
    return this.hasAttribute('readonly');
  }

  set disabled(value: boolean) {
    if (value) {
      this.setAttribute('disabled', '');
    } else {
      this.removeAttribute('disabled');
    }
  }

  get disabled(): boolean {
    return this.hasAttribute('disabled');
  }

  set hidden(value: boolean) {
    if (value) {
      this.setAttribute('hidden', '');
    } else {
      this.removeAttribute('hidden');
    }
  }

  get hidden(): boolean {
    return this.hasAttribute('hidden');
  }
}
